import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { formattaData } from '../iot/formatoData';

// Drawn and not filled, in the secondary text: being archived is a fact about
// the document, not an alert, and the row already carries a toned pill for its
// expiry.
const useStyles = makeStyles((theme) => ({
  badge: {
    display: 'inline-block',
    marginLeft: theme.spacing(1.5),
    padding: theme.spacing(0.125, 1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
  },
}));

/** «Archiviato il gg/mm/aaaa», on the day the document was archived. */
export default function ArchiviatoBadge({ dataArchiviazione }) {
  const classes = useStyles();
  const giorno = formattaData(dataArchiviazione);
  if (!giorno) return null;
  return <span className={classes.badge}>{`Archiviato il ${giorno}`}</span>;
}

ArchiviatoBadge.propTypes = {
  dataArchiviazione: PropTypes.string,
};

ArchiviatoBadge.defaultProps = {
  dataArchiviazione: null,
};
